import { ApiClient } from '@provider-portal/common/api';
import {
  GetTargetingParametersForProviderRequest,
  GetTargetingParametersForProviderResponse,
} from '@provider-portal/common/api/types';
import { combineEpics } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, timeout, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { requestAccountInfoAsyncAction, selectSelectedProvider } from 'rdx/account';
import { GlobalAppActions } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';

import { requestTargetingParametersAsyncAction } from './actions';

const getTargetingParametersForProvider = (
  apiClient: ApiClient,
  request: GetTargetingParametersForProviderRequest,
): Promise<GetTargetingParametersForProviderResponse> => {
  return apiClient.portal.getTargetingValuesForProvider(request);
};

const requestTargetingParametersEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
  { apiClient }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestTargetingParametersAsyncAction.request)),
    withLatestFrom(state$),
    switchMap(([, _state]) => {
      return action$.pipe(
        filter(isActionOf(requestAccountInfoAsyncAction.success)),
        withLatestFrom(state$),
        take(1),
        timeout(10 * 1000), // 10 seconds
        switchMap(([, newState]) => {
          const selectedProvider = selectSelectedProvider(newState);

          if (!selectedProvider || !selectedProvider.providerId) {
            return of(
              requestTargetingParametersAsyncAction.failure(
                new Error('Missed selected provider id'),
              ),
            );
          }
          return from(
            getTargetingParametersForProvider(apiClient, {
              provider_id: selectedProvider.providerId,
              city_id: selectedProvider.cityId,
              country_code: selectedProvider.countryCode,
            }),
          ).pipe(
            map((response) => requestTargetingParametersAsyncAction.success(response)),
            catchError((err) => of(requestTargetingParametersAsyncAction.failure(err))),
          );
        }),
      );
    }),
  );
};

export const targetingParametersEpic = combineEpics(requestTargetingParametersEpic);
